// Copyright (C) 2021 Bystronic Laser AG

import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { CutOrTubesIntradayAvailabilityDeviceData } from '../chartsData';
import { metricsService } from '@/services/metrics.service';
import { DataRetriever, ProcedureName } from '../abstract/chartGenerator';
import { isEmpty } from '@/utils/misc';
import { devicesService } from '@/services/devices.service';
import { WidgetEnum } from '@/models/enums/WidgetEnum';

/**
 * Retrieves data for either of the two 'Intraday availability' tables of Work
 * center console's Cut and Tubes.
 */
export class CutOrTubesIntradayAvailabilityTableRetriever extends DataRetriever<
  CutOrTubesIntradayAvailabilityDeviceData[]
> {
  constructor(procedure: ProcedureName, private customerIdDh: number) {
    super(procedure);
  }

  override async getData(
    selectedDevices: string[],
    selectedShifts: number[],
    timeSpan: [string, string] | FilterTimeSpanEnum,
    timeAxisSpan?: FilterTimeAxisSpanEnum | undefined,
    params?: { [key: string]: any } | undefined,
    customerNo?: string | undefined,
  ): Promise<CutOrTubesIntradayAvailabilityDeviceData[]> {
    return await metricsService.getCutOrTubesIntradayAvailabilityData(
      this.procedure,
      {
        tenantIdDh: this.customerIdDh,
        deviceIds: this.selectedDeviceIds(selectedDevices),
        shifts: selectedShifts,
      },
      this.controller,
    );
  }

  private selectedDeviceIds(selectedDevices: string[]): string[] {
    if (isEmpty(selectedDevices)) {
      return this.procedure === WidgetEnum.LaserIntradayAvailabilityTable
        ? devicesService.store.cutDevicesIds()
        : devicesService.store.tubeDevicesIds();
    }

    return selectedDevices;
  }
}
